import { ISearchResult, SEARCH_RESULT_TYPE } from 'src/app/shared/interfaces/search.interface';

export class SearchOperations {
  public static sortResultsByRelevance(results: ISearchResult[]): ISearchResult[] {
    return results.sort((a, b) =>
      a.type === SEARCH_RESULT_TYPE.CATEGORY ? -1 : b.type === SEARCH_RESULT_TYPE.CATEGORY ? 1 : a.type === SEARCH_RESULT_TYPE.FAQ ? 1 : b.type === SEARCH_RESULT_TYPE.FAQ ? -1 : 0
    );
  }
}
